@import "../../css/shimmer.css";
@import "../../css/button.css";

:host {
  all: initial;
  color: var(--zapier-text);
  font-family: var(--zapier-font-family);
  position: relative;
  display: block;
}

.scroll-view {
  scrollbar-color: var(--zapier-border-color) var(--zapier-bg-5);
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: calc(1.5 * var(--zapier-grid-unit));
}

.spacer {
  display: none;
}

.horizontal {
  display: flex;
  flex-direction: column;
}

ul {
  font-family: var(--zapier-font-family);
  margin: 0;
  padding: 0;
  list-style: none;
}

.zap-footer {
  color: var(--zapier-text-80);
  font-size: var(--zapier-font-size-14px);
}

.no-suggestions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(4 * var(--zapier-grid-unit));
  gap: calc(2 * var(--zapier-grid-unit));
  border-radius: calc(0.5 * var(--zapier-grid-unit));
  border: 1px solid var(--zapier-border-color);
  font-size: var(--zapier-font-size-18px);
}
